module.exports = __webpack_public_path__ + "img/Piletivahetuse_logo_valge.df759a49.svg";